import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { cmpValidation } from '../CmpUtils/cmpValidation';
import { yupResolver } from '@hookform/resolvers/yup';
import { GridForm } from '../../../../ui/styled';
import { useSelector } from 'react-redux';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import CmpORAS from './CmpORAS';
import CmpRevison from './CmpRevision';
import DischargePlan from './DischargePlan';
import Comment from './Comment';
import moment from 'moment';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../../../../common/commonUtils/commonUtils';
import {
  EPISODE_CMP_UPDATE_URL,
  formDateFormat,
  paperProps3,
} from '../../../../../constants';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { PrintButtonGrid, DialogHeader,
  DialogHeading, } from '../../../Episode.Styled';
import FormInputText from '../../../../common/Forms/FormTextField';
import { useDispatch } from 'react-redux';
import { setComments } from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EpisodeHeader from '../../EpisodeHeader'
import Typography from '@mui/material/Typography';

const CmpDialog = (props) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const { open, setOpen, openBackdrop, authToken, fetchData, episodeHeaderData } = props;

  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewCmp, setIsNewCmp] = useState(false);

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const cmpForm = useSelector((state) => state.cmpForm);

  const cmpReferenceData = useSelector((state) => state.cmpReferenceData);
  //console.log('### cmpReferenceData');
  //console.log(cmpReferenceData);
  

  const { counselingStaffAssignedList } = cmpReferenceData;

  const {
    newCmpForm,
    cmpId,
    communityBasedProvider,
    cmpEpisodeId,
    counselingStaffAssigned,
    orasGls1,
    orasGls2,
    orasGls3,
    orasObj1,
    orasObj2,
    orasObj3,
    orasTgtDt1,
    orasTgtDt2,
    orasTgtDt3,
    oracCmpDt1,
    orasCmpDt2,
    orasCmpDt3,
    revisionGoals1,
    revisionGoals2,
    revisionObjectives1,
    revisionObjectives2,
    revisionTargetDate1,
    revisionTargetDate2,
    revisionCompletedOn1,
    revisionCompletedOn2,
    dischargeGoals1,
    dischargeGoals2,
    dischargeObjectives1,
    dischargeObjectives2,
    dischargeTargetDate1,
    dischargeTargetDate2,
    comments,
    createdBy,
    createdDate,
    editBy,
    editDate,
    participant1,
    participant2,
    participant3,
    participant4,
    participant5,
    participant6,
    css1,
    css2,
    css3,
    css4,
    css5,
    css6,
    scss1,
    scss2,
    scss3,
    scss4,
    scss5,
    scss6,
    rvwDate1,
    rvwDate2,
    rvwDate3,
    rvwDate4,
    rvwDate5,
    rvwDate6,
  } = cmpForm;

  const getPhoneNumber = (cntId) => {
    const getNumber = counselingStaffAssignedList.find(
      (item) => item.cntId === cntId
    );
    return getNumber?.phone;
  };

  const defaultValue = {
    cmpId: cmpId,
    communityBasedProvider: communityBasedProvider
      ? communityBasedProvider
      : '',
    cmpEpisodeId: cmpEpisodeId,
    counselingStaffAssigned: counselingStaffAssigned
      ? counselingStaffAssigned
      : '',

    orasGls1: orasGls1,  
    orasGls2: orasGls2,  
    orasGls3: orasGls3,
    orasObj1: orasObj1,  
    orasObj2: orasObj2,  
    orasObj3: orasObj3,
    orasTgtDt1: moment(orasTgtDt1).format(formDateFormat),  
    orasTgtDt2: moment(orasTgtDt2).format(formDateFormat),  
    orasTgtDt3: moment(orasTgtDt3).format(formDateFormat),
    oracCmpDt1: moment(oracCmpDt1).format(formDateFormat), 
    orasCmpDt2: moment(orasCmpDt2).format(formDateFormat), 
    orasCmpDt3: moment(orasCmpDt3).format(formDateFormat), 
      
    revisionGoals1: revisionGoals1,
    revisionGoals2: revisionGoals2,
    revisionObjectives1: revisionObjectives1,
    revisionObjectives2: revisionObjectives2,
    revisionTargetDate1: moment(revisionTargetDate1).format(formDateFormat),
    revisionTargetDate2: moment(revisionTargetDate2).format(formDateFormat),
    revisionCompletedOn1: moment(revisionCompletedOn1).format(formDateFormat),
    revisionCompletedOn2: moment(revisionCompletedOn2).format(formDateFormat),
    dischargeGoals1: dischargeGoals1,
    dischargeGoals2: dischargeGoals2,
    dischargeObjectives1: dischargeObjectives1,
    dischargeObjectives2: dischargeObjectives2,
    dischargeTargetDate1: moment(dischargeTargetDate1).format(formDateFormat),
    dischargeTargetDate2: moment(dischargeTargetDate2).format(formDateFormat),
    comments: comments,
    createdBy: createdBy,
    createdDate: createdDate,
    editBy: editBy,
    editDate: editDate,
    participant1: participant1 ? participant1 : '',
    participant2: participant2 ? participant2 : '',
    participant3: participant3 ? participant3 : '',
    participant4: participant4 ? participant4 : '',
    participant5: participant5 ? participant5 : '',
    participant6: participant6 ? participant6 : '',
    css1: css1 ? css1 : '',
    css2: css2 ? css2 : '',
    css3: css3 ? css3 : '',
    css4: css4 ? css4 : '',
    css5: css5 ? css5 : '',
    css6: css6 ? css6 : '',
    scss1: scss1 ? scss1 : '',
    scss2: scss2 ? scss2 : '',
    scss3: scss3 ? scss3 : '',
    scss4: scss4 ? scss4 : '',
    scss5: scss5 ? scss5 : '',
    scss6: scss6 ? scss6 : '',
    rvwDate1: moment(rvwDate1).format(formDateFormat),
    rvwDate2: moment(rvwDate2).format(formDateFormat),
    rvwDate3: moment(rvwDate3).format(formDateFormat),
    rvwDate4: moment(rvwDate4).format(formDateFormat),
    rvwDate5: moment(rvwDate5).format(formDateFormat),
    rvwDate6: moment(rvwDate6).format(formDateFormat),
    phone: counselingStaffAssigned
      ? getPhoneNumber(counselingStaffAssigned)
      : '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(cmpValidation),
  });
  const { handleSubmit, reset, register, control, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    //console.log('reset')
    reset(defaultValue);
  }, [
    defaultValue.cmpId,
    defaultValue.communityBasedProvider,
    defaultValue.cmpEpisodeId,
    defaultValue.counselingStaffAssigned,
    defaultValue.orasGls1,
    defaultValue.orasGls2,
    defaultValue.orasGls3,
    defaultValue.orasObj1,
    defaultValue.orasObj2,
    defaultValue.orasObj3,
    defaultValue.orasTgtDt1,
    defaultValue.orasTgtDt2,
    defaultValue.orasTgtDt3,
    defaultValue.oracCmpDt1,
    defaultValue.orasCmpDt2,
    defaultValue.orasCmpDt3,
    defaultValue.revisionGoals1,
    defaultValue.revisionGoals2,
    defaultValue.revisionObjectives1,
    defaultValue.revisionObjectives2,
    defaultValue.revisionTargetDate1,
    defaultValue.revisionTargetDate2,
    defaultValue.revisionCompletedOn1,
    defaultValue.revisionCompletedOn2,
    defaultValue.dischargeGoals1,
    defaultValue.dischargeGoals2,
    defaultValue.dischargeObjectives1,
    defaultValue.dischargeObjectives2,
    defaultValue.dischargeTargetDate1,
    defaultValue.dischargeTargetDate2,
    defaultValue.comments,
    defaultValue.createdBy,
    defaultValue.createdDate,
    defaultValue.editBy,
    defaultValue.editDate,
    defaultValue.participant1,
    defaultValue.participant2,
    defaultValue.participant3,
    defaultValue.participant4,
    defaultValue.participant5,
    defaultValue.participant6,
    defaultValue.css1,
    defaultValue.css2,
    defaultValue.css3,
    defaultValue.css4,
    defaultValue.css5,
    defaultValue.css6,
    defaultValue.scss1,
    defaultValue.scss2,
    defaultValue.scss3,
    defaultValue.scss4,
    defaultValue.scss5,
    defaultValue.scss6,
    defaultValue.rvwDate1,
    defaultValue.rvwDate2,
    defaultValue.rvwDate3,
    defaultValue.rvwDate4,
    defaultValue.rvwDate5,
    defaultValue.rvwDate6,
    defaultValue.phone,
  ]);

  const onError = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  const onSubmit = () => {
    const url = `${EPISODE_CMP_UPDATE_URL}`;
    const authorization = authToken;
    const payload = {
      cmpId: cmpId,
      communityBasedProvider: communityBasedProvider
        ? communityBasedProvider
        : null,
      cmpEpisodeId: episodeId,
      counselingStaffAssigned: counselingStaffAssigned
        ? counselingStaffAssigned
        : null,
      
      revisionGoals1: revisionGoals1,
      revisionGoals2: revisionGoals2,
      revisionObjectives1: revisionObjectives1,
      revisionObjectives2: revisionObjectives2,
      revisionTargetDate1:
        moment(revisionTargetDate1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(revisionTargetDate1).format(formDateFormat),
      revisionTargetDate2:
        moment(revisionTargetDate2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(revisionTargetDate2).format(formDateFormat),
      revisionCompletedOn1:
        moment(revisionCompletedOn1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(revisionCompletedOn1).format(formDateFormat),
      revisionCompletedOn2:
        moment(revisionCompletedOn2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(revisionCompletedOn2).format(formDateFormat),
      

      orasGls1: orasGls1,    
      orasGls2: orasGls2,    
      orasGls3: orasGls3,
      orasObj1: orasObj1,    
      orasObj2: orasObj2,    
      orasObj3: orasObj3,    
      orasTgtDt1: moment(orasTgtDt1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(orasTgtDt1).format(formDateFormat),
      orasTgtDt2: moment(orasTgtDt2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(orasTgtDt2).format(formDateFormat),
      orasTgtDt3: moment(orasTgtDt3).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(orasTgtDt3).format(formDateFormat),
      oracCmpDt1: moment(oracCmpDt1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(oracCmpDt1).format(formDateFormat),    
      orasCmpDt2: moment(orasCmpDt2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(orasCmpDt2).format(formDateFormat),    
      orasCmpDt3: moment(orasCmpDt3).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(orasCmpDt3).format(formDateFormat),    

      dischargeGoals1: dischargeGoals1,
      dischargeGoals2: dischargeGoals2,
      dischargeObjectives1: dischargeObjectives1,
      dischargeObjectives2: dischargeObjectives2,
      dischargeTargetDate1:
        moment(dischargeTargetDate1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(dischargeTargetDate1).format(formDateFormat),
      dischargeTargetDate2:
        moment(dischargeTargetDate2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(dischargeTargetDate2).format(formDateFormat),
      participant1: participant1 ? participant1 : null,
      participant2: participant2 ? participant2 : null,
      participant3: participant3 ? participant3 : null,
      participant4: participant4 ? participant4 : null,
      participant5: participant5 ? participant5 : null,
      participant6: participant6 ? participant6 : null,
      css1: css1 ? css1 : null,
      css2: css2 ? css2 : null,
      css3: css3 ? css3 : null,
      css4: css4 ? css4 : null,
      css5: css5 ? css5 : null,
      css6: css6 ? css6 : null,
      scss1: scss1 ? scss1 : null,
      scss2: scss2 ? scss2 : null,
      scss3: scss3 ? scss3 : null,
      scss4: scss4 ? scss4 : null,
      scss5: scss5 ? scss5 : null,
      scss6: scss6 ? scss6 : null,
      rvwDate1:
        moment(rvwDate1).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate1).format(formDateFormat),
      rvwDate2:
        moment(rvwDate2).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate2).format(formDateFormat),
      rvwDate3:
        moment(rvwDate3).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate3).format(formDateFormat),
      rvwDate4:
        moment(rvwDate4).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate4).format(formDateFormat),
      rvwDate5:
        moment(rvwDate5).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate5).format(formDateFormat),
      rvwDate6:
        moment(rvwDate6).format(formDateFormat) === 'Invalid date'
          ? null
          : moment(rvwDate6).format(formDateFormat),
      comments: comments,
      createdBy: createdBy ? createdBy : 17979,
      createdDate: createdDate ? createdDate : new Date(),
      editBy: editBy ? editBy : 17979,
      editDate: editDate ? editDate : new Date(),
    };
    if (newCmpForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewCmp(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewCmp(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleClose = () => {
    //if (formState.isDirty) {
      if (window.confirm('Save Changes? Click Cancel to close without saving.') == true){
        handleSubmit(onSubmit, onError)();
      }
      else {
        setOpen(false);
        reset(defaultValue);
      }
    //}
    //else {
    //  setOpen(false);
    //  reset(defaultValue);
    //}
  };

  const getCmpForm = () => {
    return (
      <GridForm container>
        <Grid container spacing={2}>
          <Section1
            control={control}
            defaultValue={defaultValue}
            register={register}
            errors={errors}
          />
          <Section2
            control={control}
            defaultValue={defaultValue}
            register={register}
            errors={errors}
          />
          <Section3
            control={control}
            defaultValue={defaultValue}
            register={register}
          />
        </Grid>
        <div className="page-break-after" />
        <CmpORAS control={control} register={register} />
        <div className="page-break-after" />
        <CmpRevison control={control} register={register} />
        <div className="page-break-after" />
        <DischargePlan control={control} register={register} />
        {/*<Comment control={control} register={register} />*/}
        <FormInputText
            name='comments'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('comments', {
              onBlur: (e) => dispatch(setComments(e.target.value)),
            })}
          />
        
      </GridForm>
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps3}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>

            <DialogHeader>
              <Grid container style={{ padding: '0px'}}>
                
                <Grid item xs={6}>
                  <DialogHeading variant='h5'></DialogHeading>
                </Grid>
                <Grid item xs={6}>  
                <Grid container justifyContent="flex-end">
                  <Box>
                    <Button variant="contained" onClick={() => handlePrint()}>
                      Print
                    </Button>
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Grid>
                </Grid>  
              </Grid>  
            </DialogHeader>


            <Box px={4} ref={componentRef}>
              {/*{getDialogHeading('Cmp Id', defaultValue?.cmpId, handleClose)}*/}
              <Box sx={{ display: 'flex', justifyContent: 'center' }} pt={0}>
              <Box
                component="img"
                sx={{
                  display: 'flex', 
                  justifyContent: 'center',
                  height: 100,
                  width: 100,
                  maxHeight: { xs: 100, md: 100 },
                  maxWidth: { xs: 100, md: 100 },
                }}
                src="/westcare-logo.jpg"
              />
              </Box>      
              <Typography pb={2} variant="h4" align="center">
                Case Management Plan
              </Typography>
              <Grid container style={{ padding: '0px'}}>
                <EpisodeHeader data={episodeHeaderData} />
              </Grid>  

              {getCmpForm()}

              <Grid container>                
                <Grid item xs={4}>
                  <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={4} >
                    ___________________________
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={4} >
                    ___________________________
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={4} >
                    ___________________________
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={8}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        Participant Signature
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        Date
                      </Typography>
                    </Grid>
                  </Grid>    
                </Grid>
                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={8}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        CSS Signature
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        Date
                      </Typography>
                    </Grid>
                  </Grid>    
                </Grid>
                <Grid item xs={4}>
                  <Grid container>
                    <Grid item xs={8}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        Senior CSS Signature
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ textAlign: 'left' }} variant="h6" ml={0} mt={0} >
                        Date
                      </Typography>
                    </Grid>
                  </Grid>    
                </Grid>
              </Grid>    
            </Box>  
            {getSaveCancel(handleClose, null, handleSubmit(onSubmit, onError))}
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess, isNewCmp)}
    </>
  );
};

export default CmpDialog;
